import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row items-center no-wrap" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "text-grey-brand text-h6 text-bold" }
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["title"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "text-weight-bold" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "timestamp" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "timestamp" }
const _hoisted_18 = { class: "timestamp" }
const _hoisted_19 = { class: "timestamp" }
const _hoisted_20 = {
  key: 3,
  class: "q-mb-md",
  "data-test": "sim-data-usage"
}
const _hoisted_21 = {
  key: 0,
  class: "text-deep-orange-10 text-weight-medium",
  "data-test": "sim-data-usage-warning"
}
const _hoisted_22 = { class: "timestamp text-caption" }
const _hoisted_23 = {
  key: 1,
  class: "text-caption"
}
const _hoisted_24 = { class: "timestamp text-caption text-grey-7" }
const _hoisted_25 = {
  key: 4,
  class: "text-grey-7",
  "data-test": "sim-data-usage-unavailable"
}
const _hoisted_26 = {
  key: 5,
  class: "text-grey-7",
  "data-test": "sim-data-usage-no-sim"
}
const _hoisted_27 = { key: 6 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { style: {"color":"red"} }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "timestamp" }
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { style: {"color":"red"} }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { style: {} }
const _hoisted_37 = { key: 8 }
const _hoisted_38 = { key: 9 }
const _hoisted_39 = { class: "timestamp" }
const _hoisted_40 = { key: 10 }
const _hoisted_41 = { key: 11 }
const _hoisted_42 = { key: 12 }
const _hoisted_43 = { key: 13 }
const _hoisted_44 = { key: 14 }
const _hoisted_45 = { class: "float-right q-pr-xl" }
const _hoisted_46 = { class: "float-right q-pr-xl" }
const _hoisted_47 = { class: "float-right q-pr-xl" }
const _hoisted_48 = { class: "float-right q-pr-xl" }
const _hoisted_49 = {
  key: 0,
  class: "float-right q-pr-xl"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 2,
  class: "float-right q-pr-xl"
}
const _hoisted_52 = { key: 15 }
const _hoisted_53 = { class: "timestamp" }
const _hoisted_54 = { key: 16 }
const _hoisted_55 = { class: "timestamp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_DeviceActions = _resolveComponent("DeviceActions")!
  const _component_ViewerDeviceActions = _resolveComponent("ViewerDeviceActions")!
  const _component_q_card = _resolveComponent("q-card")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.device?.uid)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          square: "",
          flat: "",
          bordered: "",
          class: "my-card bg-grey-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_q_avatar, {
                        size: "xs",
                        color: _ctx.device.isConnected ? 'positive' : 'grey-6',
                        "text-color": "white"
                      }, null, 8, ["color"]),
                      _createTextVNode(" UID: " + _toDisplayString(_ctx.device ? _ctx.device.uid : '') + " ", 1),
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "highlight_off",
                          color: "red-4",
                          onClick: _ctx.clearSelection
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, null, {
                              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                _createTextVNode("Clear selection", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        (_ctx.device.isIridium)
                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_5, [
                              _createElementVNode("img", {
                                class: "q-mr-sm",
                                src: _ctx.iridiumSignalIconSrc(_ctx.device.lastSignalStrength)
                              }, null, 8, _hoisted_6)
                            ], 512)), [
                              [_vShow, _ctx.device.lastSignalStrength]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                              (_ctx.device.lastSignalStrength >= -80)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "q-mr-sm",
                                    src: "signal-5.png",
                                    title: _ctx.device.lastSignalStrength + ' dBm'
                                  }, null, 8, _hoisted_8))
                                : (_ctx.device.lastSignalStrength >= -90)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      class: "q-mr-sm",
                                      src: "signal-4.png",
                                      title: _ctx.device.lastSignalStrength + ' dBm'
                                    }, null, 8, _hoisted_9))
                                  : (_ctx.device.lastSignalStrength > -100)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        class: "q-mr-sm",
                                        src: "signal-3.png",
                                        title: _ctx.device.lastSignalStrength + ' dBm'
                                      }, null, 8, _hoisted_10))
                                    : (_ctx.device.lastSignalStrength < -100)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 3,
                                          class: "q-mr-sm",
                                          src: "signal-2.png",
                                          title: _ctx.device.lastSignalStrength + ' dBm'
                                        }, null, 8, _hoisted_11))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 4,
                                          class: "q-mr-sm",
                                          src: "signal-1.png",
                                          title: _ctx.device.lastSignalStrength + ' dBm'
                                        }, null, 8, _hoisted_12))
                            ], 512)), [
                              [_vShow, _ctx.device.lastSignalStrength]
                            ]),
                        _withDirectives(_createElementVNode("span", null, [
                          (_ctx.device.lastBattery > 9000)
                            ? (_openBlock(), _createBlock(_component_q_icon, {
                                key: 0,
                                name: "fas fa-battery-full",
                                title: "100%"
                              }))
                            : (_ctx.device.lastBattery > 8500)
                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 1,
                                  name: "fas fa-battery-three-quarters",
                                  title: "80%"
                                }))
                              : (_ctx.device.lastBattery > 8000)
                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                    key: 2,
                                    name: "fas fa-battery-three-quarters",
                                    title: "60%"
                                  }))
                                : (_ctx.device.lastBattery > 7500)
                                  ? (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 3,
                                      name: "fas fa-battery-half",
                                      title: "40%"
                                    }))
                                  : (_ctx.device.lastBattery > 7000)
                                    ? (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 4,
                                        name: "fas fa-battery-quarter",
                                        title: "20%"
                                      }))
                                    : (_openBlock(), _createBlock(_component_q_icon, {
                                        key: 5,
                                        name: "fas fa-battery-empty",
                                        title: "0%"
                                      }))
                        ], 512), [
                          [_vShow, _ctx.device.lastBattery]
                        ]),
                        _withDirectives(_createElementVNode("span", null, [
                          _createVNode(_component_q_icon, {
                            class: "q-ml-sm",
                            name: "fas fa-satellite-dish",
                            title: "Iridium"
                          })
                        ], 512), [
                          [_vShow, _ctx.device.isIridium]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            (_ctx.linkedPigRun.length)
              ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_13, "Active Pig Run: " + _toDisplayString(_ctx.linkedPigRun), 1),
                    _createVNode(_component_q_btn, {
                      size: "sm",
                      icon: "fas fa-map-marker",
                      class: "btn-brand",
                      label: "Go To Pig Run",
                      "no-caps": "",
                      onClick: _ctx.goToPigRun
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.getuser() == 'superadmin')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", { style: {"color":"red"} }, "Currently logged on as super admin.", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _cache[3] || (_cache[3] = _createTextVNode(" Heartbeat: ", -1)),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.device && _ctx.device.lastHeartbeat
              ? _ctx.device.lastHeartbeat.slice(0, -7)
              : ''), 1)
                ]),
                (_ctx.displayCellularCarrierInfo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, "Primary Carrier: " + _toDisplayString(_ctx.cellularCarrierInfoPrimaryCarrier), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_18, "Active Carrier: " + _toDisplayString(_ctx.cellularCarrierInfoActiveCarrier), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_19, "Status: " + _toDisplayString(_ctx.cellularCarrierInfoRegistrationStatus), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.simDataUsageKind === 'limit')
                  ? (_openBlock(), _createBlock(_component_q_banner, {
                      key: 2,
                      dense: "",
                      rounded: "",
                      class: "bg-negative text-white q-mb-sm",
                      "data-test": "sim-data-limit-banner"
                    }, {
                      avatar: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: "signal_cellular_off" })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.simDataLimitBanner), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.simDataUsageHasFigures)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_ctx.simDataUsageKind === 'warning')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_q_icon, {
                              name: "warning",
                              color: "deep-orange-10"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.simDataWarning), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", {
                        class: _normalizeClass({
              'text-deep-orange-10': _ctx.simDataUsageKind === 'warning',
              'text-negative text-weight-bold': _ctx.simDataUsageKind === 'limit',
            })
                      }, _toDisplayString(_ctx.simDataUsageText), 3),
                      _createVNode(_component_q_linear_progress, {
                        value: _ctx.simDataUsageProgressValue,
                        color: _ctx.simDataUsageBarColor,
                        "track-color": "grey-4",
                        size: "8px",
                        rounded: "",
                        class: "q-my-xs",
                        "aria-label": "Cellular data used"
                      }, null, 8, ["value", "color"]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.simDataResetText), 1),
                      (_ctx.simDataResetText && _ctx.simDataUpdatedText)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, " · "))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.simDataUpdatedText), 1)
                    ]))
                  : (_ctx.simDataUsageKind === 'unavailable')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.simDataUnavailableText), 1))
                    : (_ctx.simDataUsageKind === 'nosim')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.simDataNoSimText), 1))
                      : _createCommentVNode("", true),
                (_ctx.displayDiskUsageBySize)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (_ctx.displayDiskUsageBySizeAsWarning)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", _hoisted_29, "Disk Usage (MB): " + _toDisplayString(_ctx.diskUseMBytes) + " of " + _toDisplayString(_ctx.diskSizeMBytes), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"color":"red"} }, "Disk format recommended.", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("span", _hoisted_31, "Disk Usage (MB): " + _toDisplayString(_ctx.diskUseMBytes) + " of " + _toDisplayString(_ctx.diskSizeMBytes), 1),
                            _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1))
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.displayDiskUsageByFileCount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      (_ctx.displayDiskUsageByFileCountAsWarning)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, "Disk Usage (File Counts): Offline = " + _toDisplayString(_ctx.numberOfflineFiles != undefined
                  ? _ctx.numberOfflineFiles
                  : 'Unknown') + ", Online = " + _toDisplayString(_ctx.numberOnlineFiles != undefined ? _ctx.numberOnlineFiles : 'Unknown'), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                            _cache[13] || (_cache[13] = _createElementVNode("span", { style: {"color":"red"} }, "Disk format recommended.", -1)),
                            _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("span", _hoisted_36, "Disk Usage (File Counts): Offline = " + _toDisplayString(_ctx.numberOfflineFiles != undefined
                  ? _ctx.numberOfflineFiles
                  : 'Unknown') + ", Online = " + _toDisplayString(_ctx.numberOnlineFiles != undefined ? _ctx.numberOnlineFiles : 'Unknown'), 1),
                            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1))
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, "Power Mode: " + _toDisplayString(_ctx.device ? _ctx.device.lastPowerMode : ''), 1),
                (_ctx.device.lastPowerMode !== 'Active')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, " Schedule: " + _toDisplayString(_ctx.device.schedule), 1))
                  : _createCommentVNode("", true),
                (_ctx.lastPassage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                      _cache[18] || (_cache[18] = _createTextVNode(" Last Passage: ", -1)),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.lastPassage.slice(0, -7)), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastPassagesData, (passage) => {
                        return (_openBlock(), _createBlock(_component_q_btn, {
                          key: passage.passageId,
                          size: "xs",
                          class: "q-mr-xs btn-brand",
                          dense: "",
                          icon: "show_chart",
                          label: _ctx.getPassageWaveformLabel(passage),
                          onClick: ($event: any) => (_ctx.showChart(passage))
                        }, null, 8, ["label", "onClick"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_40, "Last Passage: None")),
                (!_ctx.device.isIridium)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
                      _createTextVNode(" Stream Mode: " + _toDisplayString(_ctx.lastStreamModeText()) + " ", 1),
                      _createVNode(_component_q_btn, {
                        size: "xs",
                        class: "btn-brand",
                        dense: "",
                        icon: "fas fa-headphones",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showStreamer(_ctx.device.uid)))
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_42, [
                      _createElementVNode("p", null, "Passage State: " + _toDisplayString(_ctx.passageStateText()), 1),
                      _createElementVNode("p", null, "Passage Size: " + _toDisplayString(_ctx.passageSizeText()), 1)
                    ])),
                _createElementVNode("p", null, " Record Mode: " + _toDisplayString(_ctx.device.lastRecordMode ? _ctx.device.lastRecordMode : 'Unknown'), 1),
                (_ctx.showGeoMode)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_43, " Geo Mode: " + _toDisplayString(_ctx.formatGeoSetting(_ctx.device.lastGeoMode)), 1))
                  : _createCommentVNode("", true),
                (_ctx.device.lastFrequency0Setting >= 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                      _cache[19] || (_cache[19] = _createTextVNode(" Detectors: ", -1)),
                      _createElementVNode("span", _hoisted_45, [
                        _createTextVNode(_toDisplayString('Mag') + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity0)) + ") ", 1),
                        _createVNode(_component_q_icon, {
                          name: _ctx.device.lastEnable0 ? 'check' : 'close'
                        }, null, 8, ["name"])
                      ]),
                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_46, [
                        _createTextVNode(_toDisplayString(_ctx.formatDetectorSetting(_ctx.device.lastFrequency1Setting)) + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity1)) + ") ", 1),
                        _createVNode(_component_q_icon, {
                          name: _ctx.device.lastEnable1 ? 'check' : 'close'
                        }, null, 8, ["name"])
                      ]),
                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_47, [
                        _createTextVNode(_toDisplayString(_ctx.formatDetectorSetting(_ctx.device.lastFrequency2Setting)) + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity2)) + ") ", 1),
                        _createVNode(_component_q_icon, {
                          name: _ctx.device.lastEnable2 ? 'check' : 'close'
                        }, null, 8, ["name"])
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.formatDetectorSetting(_ctx.device.lastFrequency3Setting)) + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity3)) + ") ", 1),
                        _createVNode(_component_q_icon, {
                          name: _ctx.device.lastEnable3 ? 'check' : 'close'
                        }, null, 8, ["name"])
                      ]),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                      (_ctx.device.deviceType === 'AGMVECTOR')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                            _createTextVNode(_toDisplayString('In-Geo') + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity4)) + ") ", 1),
                            _createVNode(_component_q_icon, {
                              name: _ctx.device.lastEnable4 ? 'check' : 'close'
                            }, null, 8, ["name"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.device.deviceType === 'AGMVECTOR')
                        ? (_openBlock(), _createElementBlock("br", _hoisted_50))
                        : _createCommentVNode("", true),
                      (_ctx.device.deviceType === 'AGMVECTOR')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                            _createTextVNode(_toDisplayString('Tmr') + "(" + _toDisplayString(_ctx.lastSensitivityText(_ctx.device.lastSensitivity5)) + ") ", 1),
                            _createVNode(_component_q_icon, {
                              name: _ctx.device.lastEnable5 ? 'check' : 'close'
                            }, null, 8, ["name"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.expectedWakeupTime.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                      _cache[24] || (_cache[24] = _createTextVNode(" Expected Wakeup Time: ", -1)),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.expectedWakeupTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.shutdownTime.length && !_ctx.device.isConnected)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                      _cache[25] || (_cache[25] = _createTextVNode(" Shutdown Time: ", -1)),
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.shutdownTime), 1)
                    ]))
                  : _createCommentVNode("", true),
                _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1))
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            (_ctx.getuser() == 'superadmin' || _ctx.getuser() == 'admin')
              ? (_openBlock(), _createBlock(_component_DeviceActions, { key: 1 }))
              : _createCommentVNode("", true),
            (_ctx.getuser() == 'viewer')
              ? (_openBlock(), _createBlock(_component_ViewerDeviceActions, { key: 2 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_q_card, {
          key: 1,
          square: "",
          flat: "",
          bordered: "",
          class: "my-card bg-grey-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createElementVNode("div", { class: "row items-center no-wrap" }, [
                  _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("div", { class: "text-h6 text-weight-bold text-grey-brand" }, " No Devices Selected ")
                  ])
                ], -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
  ], 512)), [
    [_vShow, _ctx.inPopup || _ctx.showDeviceInfo]
  ])
}